<div *transloco="let t; prefix: 'shared.errorPage'" class="flex flex-col px-4 py-14 gap-10 md:flex-row justify-between lg:pl-[72px] lg:pr-[178px] lg:py-[72px]" style="height: calc(100vh - 84px);">
	<div class="flex flex-col justify-center gap-10 md:w-[489px]">
		<div class="self-stretch text-black text-7xl font-semibold">{{t('title')}}</div>
		<div class="self-stretch h-24 flex-col justify-center items-start gap-4 flex">
		<div class="self-stretch text-black text-[32px] font-normal ">{{t('subtitle')}}</div>
		<div class="self-stretch text-[#50575f] text-base font-normal">
			{{t('description')}}
		</div>
		</div>
		<div class="px-5 py-4 bg-primary-500 rounded-2xl self-start">
			<button class="text-black text-base font-semibold" [localizedRouterLink]="['/home']">
				{{t('buttonLabel')}}
			</button>
		</div>
		</div>
	<div class="flex justify-end w-full lg:w-auto relative content-center items-center">
		<img class="w-full md:w-[471px] md:h-[493.39px] lg:w-auto" src="./assets/img/error-pages/error.png" />
	</div>
</div>